module.exports = __webpack_public_path__ + "static/media/20.96898c21.jpg";